<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/lgmQte/tc-custom/9780062953728.jpg?1718252299842" alt="This image is the cover for the book Surrender, White People!"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Surrender, White People!
      </h1>
      <p class="bookDescription body article font2">
        <p><b>THE NATIONAL BESTSELLER</b></p><p><b>"Hughley uses his trademark humor to address the stark divisions in society that stem from centuries of white supremacy." —<i>People</i></b></p><p><b>Surrender, white people! After 400 years of white supremacy in America, a reckoning is here. </b><b>These are the terms of peace–and they are unconditional. </b><b>Hope you brought a sense of humor, because this is gonna sting.</b></p><p>After centuries of oppressing others, white people are in for a surprise: You’re about to be a minority yourself. Yes, the face of America is getting a lot browner—and a reckoning is coming. Black and brown folk are not going to take a back seat anymore. It’s time to surrender your unjust privileges and sue for peace while the getting’s still good. Lucky for America, D.L. Hughley has a plan.</p><p>On the eve of America becoming a majority-minority nation, Hughley warns, the only way for America to move forward peacefully is if Whites face their history, put aside all their visions of superiority, and open up their institutions so they benefit everyone in this nation.  But we can still have fun with this right?  <i>Surrender, White People!</i> hilariously holds America account for its wrongs and offers D.L.'s satirical terms for reparations and reconciliation.</p><p>But it’s not all bad news, white folks. The upside is that if you put D.L.’s plan into effect, you can FINALLY get black people to stop talking about oppression, discrimination, and their place in America. Now, that’s something we ALL can get behind.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        D. L. Hughley, Doug Moe
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollins
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2204b247